import { Input, FormFeedback, Label } from '@polichat/flamboyant';
import { Controller, useFormContext } from 'react-hook-form';
import { ORIGIN_OPTIONS, ORIGIN_VALUES } from '../useFinishChatForm/types';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';
import { useMemo } from 'react';

import styles from '../styles.module.css';

export function OriginForm() {
  const { control } = useFormContext();
  const reasonForServiceText = useGlotaT(
    'spa.chat.finishChat.reasonForService'
  );

  // Traduções para opções de origem
  const commercialText = useGlotaT('spa.chat.finishChat.commercial');
  const supportText = useGlotaT('spa.chat.finishChat.supportText');
  const financialText = useGlotaT('spa.chat.finishChat.financialText');
  const othersText = useGlotaT('spa.chat.finishChat.others');

  // Opções traduzidas
  const translatedOriginOptions = useMemo(
    () =>
      ORIGIN_OPTIONS.map((opt) => {
        let label = opt.label;
        if (opt.value === ORIGIN_VALUES.commercial) label = commercialText;
        else if (opt.value === ORIGIN_VALUES.support) label = supportText;
        else if (opt.value === ORIGIN_VALUES.financial) label = financialText;
        else if (opt.value === ORIGIN_VALUES.other) label = othersText;
        return { ...opt, label };
      }),
    [commercialText, supportText, financialText, othersText]
  );

  return (
    <div className={styles.fieldContainer}>
      <Controller
        name="origin"
        control={control}
        render={({ field, fieldState }) => (
          <>
            <Label
              htmlFor="origin"
              className={styles.fieldLabel}
              data-testid="finish-chat-origin-label"
            >
              {reasonForServiceText}
              <span className={styles.fieldLabelRequired}>*</span>
            </Label>
            <Input
              id="origin"
              type="select"
              {...field}
              invalid={!!fieldState.error}
              data-testid="finish-chat-origin-select"
            >
              {translatedOriginOptions.map((option) => (
                <option
                  key={option.value}
                  value={option.value}
                  data-testid={`finish-chat-origin-option-${option.value}`}
                >
                  {option.label}
                </option>
              ))}
            </Input>
            {fieldState.error && (
              <FormFeedback data-testid="finish-chat-origin-error">
                {fieldState?.error?.message}
              </FormFeedback>
            )}
          </>
        )}
      />
    </div>
  );
}
